import {
  AirVent, Sparkles, Bug, Droplets, Shirt, Hammer, HardHat, Sofa, DraftingCompass, PaintRoller, Zap, Wrench,
  House, Axe, Tv, UtensilsCrossed, Camera, Brush, Flower2, Cake, Building2, PenTool, Globe, Truck, Leaf, Briefcase,
} from "lucide-react";

const ICONS = {
  AirVent, Sparkles, Bug, Droplets, Shirt, Hammer, HardHat, Sofa, DraftingCompass, PaintRoller, Zap, Wrench,
  House, Axe, Tv, UtensilsCrossed, Camera, Brush, Flower2, Cake, Building2, PenTool, Globe, Truck, Leaf,
};

export const CategoryIcon = ({ name, className = "h-5 w-5" }) => {
  const Icon = ICONS[name] || Briefcase;
  return <Icon className={className} strokeWidth={1.75} />;
};
